import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { authAPI } from '@/services/auth.service';
import { VendorRegistrationPayload } from '@/types';
import { useNavigate } from 'react-router-dom';
import { handleAnyError } from '@/lib/utils';

export const useVendorRegistration = () => {
    const navigate = useNavigate();

    return useMutation<any, Error, VendorRegistrationPayload>({
        mutationFn: (payload) => authAPI.register(payload),
        onSuccess: () => {
            toast.success('Registration successful! Please check your email to verify your account.', {
                id: 'vendor-register',
            });
            navigate('/login');
        },
        onError: handleAnyError
    });
};
